module.exports = __webpack_public_path__ + "static/todoist_3-8f30dfe0b0d6f14d91606202968651a6.png";